<template>
  <div class="container">
    <h1>Bedankt voor uw inzending</h1>
    <a href="#" @click.prevent="restart" class="btn btn-primary"
      >Terug naar de startpagina</a
    >
  </div>
</template>

<script>
export default {
  name: "Thanks",
  methods: {
    restart() {
      this.$router.push({ name: "home" });
      this.$store.dispatch("restart");
    }
  }
};
</script>
